import { PagedSearch } from '../../../shared/model/index';

export class ArcSearch extends PagedSearch {
  public ItemNum: number;
  public Inactive: boolean;
  public Descr: string;
}
